import * as loglevel from 'loglevel';

declare let window: any;

export class Logger {
  private name: string;

  private isFunction = false;

  constructor(private nameOrFunction: string | Function) {
    // new
    if (typeof nameOrFunction === 'string') {
      this.name = nameOrFunction;
    } else {
      this.name = nameOrFunction.name ? nameOrFunction.name : nameOrFunction.constructor.name;
      this.isFunction = true;
    }

    loglevel.setLevel(loglevel.levels.TRACE);

    // console.log('Logger(): set logger name to', this.name);
  }

  static setLogLevel(level: 'silent' | 'trace' | 'debug' | 'info' | 'warn' | 'error') {
    loglevel.setLevel(level);
  }

  haveDebugLevelTransport() {
    return loglevel.getLevel() <= loglevel.levels.DEBUG;
  }

  haveInfoLevelTransport() {
    return loglevel.getLevel() <= loglevel.levels.INFO;
  }

  debug(...parameters: any[]) {
    if (this.haveDebugLevelTransport()) {
      loglevel.debug(...this.processParams(parameters));
    }
  }

  info(...parameters: any[]) {
    if (this.haveInfoLevelTransport()) {
      loglevel.info(...this.processParams(parameters));
    }
  }

  warn(...parameters: any[]) {
    loglevel.warn(...this.processParams(parameters));
  }

  error(...parameters: any[]) {
    loglevel.error(...this.processParams(parameters));
  }

  processParams(parameters: any[]) {
    parameters = [this.name + (this.isFunction ? (!!parameters && parameters.length > 0 ? '():' : '()') : ': ')].concat(parameters);
    return parameters;
  }
}
